import React from 'react'
import { browserHistory } from 'react-router'
import update from 'immutability-helper';

import NavLink from '../../Routes/NavLink'
import LeaseSelect from '../../Leases/LeaseSelect'

import { spaces } from '../../../core/controllers/Spaces'
import { modal } from '../../../core/utilities/modal'

export default class Space extends React.Component {
    constructor(props) {
        super(props);

        var alreadyMovedIn = false;
        var assignedLease = false;
        var contract_id = 0;

        if(this.props.data.contract_data) {
            assignedLease = true;
            contract_id = this.props.data.contract_data.contract_id;
        }

        if(this.props.data.tenant_data) {
            alreadyMovedIn = true;
        }
        // #  Need to make sure that we are not forcing other components that 
        // want to use this functionality, to specify another component name
        // e.g. spaceDataID should be id so it is generic
        this.state = {
            minimized: false,
            spaceDetails: {
                taskTitle: (this.props.data.space_data.title || ""),
                spaceDataID: (this.props.data.space_data.space_data_id || 0),
                tenantID: (this.props.data.space_data.tenant_id || 0),
                alreadyMovedIn: alreadyMovedIn,
                assignedLease: assignedLease,
                contract_id: contract_id,
                uuid: this.props.data.uuid
            },
            contractData: this.props.data.contract_data,
            tenantData: this.props.data.tenant_data,
            sensorUuid: '',
            sensorIdentifier: '',
            sensorActive: 0,
            getDataAgain: false,
            reloadData: false
        }
        if(this.props.data.space_data.meta_data === undefined){
            this.state.lastUpdated = "";
        } else {
            this.state.lastUpdated = this.props.data.space_data.meta_data.last_updated;
            if(this.props.data.space_data.meta_data.sensor_data) {
                this.state.sensorUuid   = this.props.data.space_data.meta_data.sensor_data.sensor_uuid;
                this.state.sensorIdentifier   = this.props.data.space_data.meta_data.sensor_data.sensor_identifier;
                this.state.sensorActive = this.props.data.space_data.meta_data.sensor_data.active;
            }
        }
    }

    componentDidMount() {
        // #  We need to setup our slimScroll on our editing window
		jQuery(jQuery('.single-task-card .scroll-attach')).slimScroll({
            height: '150px',
			alwaysVisible: true
		});
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.getDataAgain) {
            // get a reload of data
            this.reloadData(nextProps.data.uuid);
            nextState.getDataAgain = false;
        } else if (nextState.reloadData) {
            var alreadyMovedIn = false;
            var assignedLease = false;
            var contract_id = 0;
            if(this.props.data.uuid !== nextProps.data.uuid) {
                nextState.spaceDetails.alreadyMovedIn = alreadyMovedIn,
                nextState.spaceDetails.assignedLease = assignedLease,
                nextState.spaceDetails.contract_id = contract_id,
                nextState.reloadData = false;
                return;
            }
            if(nextState.taskData.contract_data) {
                assignedLease = true;
                contract_id = nextState.taskData.contract_data.contract_id;
            }
            if(nextState.taskData.tenant_data) {
                alreadyMovedIn = true;
            }

            if(nextState.taskData.space_data.meta_data === undefined){
                nextState.lastUpdated = "";
            } else {
                if(nextState.taskData.space_data.meta_data.sensor_data) {
                    nextState.lastUpdated  = nextState.taskData.space_data.meta_data.last_updated;
                    nextState.sensorUuid   = nextState.taskData.space_data.meta_data.sensor_data.sensor_uuid;
                    nextState.sensorIdentifier   = nextState.taskData.space_data.meta_data.sensor_data.sensor_identifier;
                    nextState.sensorActive = nextState.taskData.space_data.meta_data.sensor_data.active;
                }
            }

            nextState.spaceDetails.taskTitle      = (nextState.taskData.space_data.title || ""),
            nextState.spaceDetails.spaceDataID    = (nextState.taskData.space_data.space_data_id || 0),
            nextState.spaceDetails.tenantID       = (nextState.taskData.space_data.tenant_id || 0),
            nextState.spaceDetails.alreadyMovedIn = alreadyMovedIn,
            nextState.spaceDetails.assignedLease  = assignedLease,
            nextState.spaceDetails.contract_id    = contract_id,
            nextState.spaceDetails.uuid           = nextState.taskData.space_data.uuid,
            nextState.contractData                = nextState.taskData.contract_data,
            nextState.tenantData                  = nextState.taskData.tenant_data;
            nextState.reloadData                  = false;
        }
    }

    // #  minimizes SingleTask
    minimizeTask(e) {
        // #  update
        this.setState({
            minimized: true
        });
    }
    /**
    *
    * Maximizes SingleTask
    *
    */
    maximizeTask(e) {
        // #  update
        this.setState({
            minimized: false
        });
    }
    /**
    *
    * Updates title
    *
    */
    handleTitleChange(e) {
        this.setState({
            spaceDetails: update(this.state.spaceDetails, {
                taskTitle: {$set: e.target.value}
            })
        });
    }

    handleSensorUuidChange(e) {
        this.setState({
            sensorUuid: e.target.value
        });
    }

    sensorIdentifierChange(e) {
        this.setState({
            sensorIdentifier: e.target.value
        });
    }
    /**
    *
    * Saves space data
    *
    */
    handleSaveSpaceData(e) {
        spaces.saveSpaceDetails(this);
    }
    /**
    *
    * Deletes space data
    *
    */
    handleDeleteSpaceData(e) {
        spaces.removeSpaceDetails(this);
    }

    disableAlarm(e) {
        spaces.disableAlarm(this);
    }
    /**
    *
    * Deletes space data and 3d build
    *
    */
    handleDeleteSpaceDataAndSpace(e) {
        spaces.removeSpaceDetailsAnd3DBuild(this);
    }
    /**
     * Remove out associated lease
     * @param {*} e 
     */
    handleMoveOut(e) {
        spaces.moveOut(this);
    }

    /**
     * handles state update of tenant select list
     * @param {*} e 
     */
    sortLeaseSelect(e) {
        this.setState({
            spaceDetails: update(this.state.spaceDetails, {
                contract_id: {$set: e.target.value
                }}
            )
        });
    }
    /**
     * Reloads task data.  Main use is for the graphical re-render of color states
     * @param {*} uuid 
     * @param {*} position 
     */
    reloadData(uuid) {
        spaces.getSpace(uuid, this);
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e 
     */
    formatAmount(value) {
        // format money
        var money = parseFloat(value);
        if(isNaN(money) || money === 0) {
            money = 0;
        } else {
            money = money / 100;
            money.toLocaleString("en-US", {style:"currency", currency:"USD"});
        }

        return money;
    }

    render(){
        const spaceDataID = this.state.spaceDetails.spaceDataID;
        const contractData = this.state.contractData;
        const tenantData = this.state.tenantData;
        const isMinimized = this.props.isMinimized;
        const assignedLease = this.state.spaceDetails.assignedLease;
        const alreadyMovedIn = this.state.spaceDetails.alreadyMovedIn;
        const sensorActive = this.state.sensorActive;
        if(!isMinimized) {
            if(sensorActive == 1) {
                return (
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.minimizeTask}><i class="pe-7s-angle-down"></i></button>
                            <h4 class="title"onClick={this.props.minimizeTask}>Editing Space <span class="active-alarm"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Active Alarm</span></h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <div class="scroll-attach">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Space Title</label>
                                            <input type="text" class="form-control" disabled name="title" placeholder="Space Title" value={this.state.spaceDetails.taskTitle} id="title" onChange={this.handleTitleChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="clearfix"></div>
                                    <div class="header">
                                        <h5 class="title">Sensor Information</h5>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Controller UUID</label>
                                            <input type="text" class="form-control" disabled name="title" placeholder="Controller UUID" value={this.state.sensorUuid} id="sensoruuid" onChange={this.handleSensorUuidChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Device Identifier</label>
                                            <input type="text" class="form-control" disabled name="title" placeholder="Device Identifier" value={this.state.sensorIdentifier} id="sensoridentifier" onChange={this.sensorIdentifierChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer">
                                <div class="legend">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-warning btn-fill pull-right" autoComplete="off" onClick={this.disableAlarm.bind(this)}>
                                    Turn Off Alarm
                                    </button>
                                    <div class="clearfix"></div>
                                </div>
                                <hr/>
                                <div class="stats">
                                    <i class="fa fa-clock-o"></i> Last updated {this.state.lastUpdated}
                                    {contractData && (
                                        <span>
                                            <i class="fa fa-usd"></i>{this.formatAmount(contractData.contract_amount)} - {contractData.payment_recurrence_method}ly
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            } else if(spaceDataID === undefined || spaceDataID == 0) {
                return (
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.minimizeTask}><i class="pe-7s-angle-down"></i></button>
                            <h4 class="title" onClick={this.props.minimizeTask}>Editing Space</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <div class="scroll-attach">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Space Title</label>
                                            <input type="text" class="form-control" name="title" placeholder="Space Title" value={this.state.spaceDetails.taskTitle} id="title" onChange={this.handleTitleChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer">
                                <div class="legend">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleDeleteSpaceDataAndSpace.bind(this)}>
                                    Delete
                                    </button>
                                    <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleSaveSpaceData.bind(this)}>
                                    Save
                                    </button>
                                    <div class="clearfix"></div>
                                </div>
                                <hr/>
                                <div class="stats">
                                </div>
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.minimizeTask}><i class="pe-7s-angle-down"></i></button>
                            <h4 class="title"onClick={this.props.minimizeTask}>Editing Space</h4>
                            <p class="category"></p>
                        </div>
                        <div class="content">
                            <div class="scroll-attach">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Space Title</label>
                                            <input type="text" class="form-control" name="title" placeholder="Space Title" value={this.state.spaceDetails.taskTitle} id="title" onChange={this.handleTitleChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="clearfix"></div>
                                    <div class="header">
                                        <h5 class="title">Sensor Information</h5>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Controller UUID</label>
                                            <input type="text" class="form-control" name="title" placeholder="Controller UUID" value={this.state.sensorUuid} id="sensoruuid" onChange={this.handleSensorUuidChange.bind(this)}/>
                                        </div>
                                    </div>
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label>Device Identifier</label>
                                            <input type="text" class="form-control" name="title" placeholder="Device Identifier" value={this.state.sensorIdentifier} id="sensoruuid" onChange={this.sensorIdentifierChange.bind(this)}/>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    { assignedLease == false ? (
                                        <div class="col-md-5">
                                            <div class="form-group">
                                                <label>Assign Lease - Connect a Lease</label>
                                                <br/>
                                                <LeaseSelect columnSize={12} title="" onChange={this.sortLeaseSelect.bind(this)} selectIdType={"contract_id"} showAll={false} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                        { alreadyMovedIn == false ? (
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>Move In - Connect a Tenant</label>
                                                    <br/>
                                                    <NavLink to={/lease/ + contractData.contract_id + "/movein"}>
                                                        <button type="button" data-loading-text="Loading..." class="btn btn-warning btn-fill" autoComplete="off">
                                                        Move In
                                                        </button>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        ) : (
                                            <div>
                                            <div class="header">
                                                <h5 class="title">Tenant Information</h5>
                                                {contractData ? (
                                                    <p class="category">active lease agreement</p>
                                                ) : (
                                                    <p class="category">no active lease agreement</p>
                                                )}
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>Firstname</label>
                                                    <input type="text" class="form-control" name="firstname" placeholder="Firstname" value={tenantData.tenant_firstname} id="firstname" disabled />                                                    
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>Lastname</label>
                                                    <input type="text" class="form-control" name="lastname" placeholder="Lastname" value={tenantData.tenant_lastname} id="lastname" disabled />                                                    
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>Move Out</label>
                                                    <br/>
                                                    <button type="button" data-loading-text="Loading..." class="btn btn-warning btn-fill" autoComplete="off" onClick={this.handleMoveOut.bind(this)}>
                                                    Move Out
                                                    </button>
                                                </div>
                                            </div>
                                            </div>
                                        )}
                                        {contractData && (
                                            <div>
                                            <div class="clearfix"></div>
                                            <div class="header">
                                                <h5 class="title">Lease Information</h5>
                                                <p class="category">
                                                    <NavLink to={"/lease/" + contractData.contract_id}>
                                                    view lease
                                                    </NavLink>
                                                </p>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>Lease Title</label>
                                                    <input type="text" class="form-control" name="contracttitle" placeholder="Lease Title" value={contractData.title} id="contracttitle" disabled />
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>Lease Effective Date</label>
                                                    <input type="text" class="form-control" name="effectivedate" placeholder="Lease Title" value={contractData.effective_date} id="effectivedate" disabled />
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>Lease Amout</label>
                                                    <input type="text" class="form-control" name="contractamout" placeholder="Lease Amount" value={this.formatAmount(contractData.contract_amount)} id="contractamount" disabled />
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group">
                                                    <label>Sqft</label>
                                                    <input type="text" class="form-control" name="contractamout" placeholder="Lease Amount" value={contractData.sqft  + " Sqft"} id="sqft" disabled />
                                                </div>
                                            </div>
                                            </div>
                                        )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div class="footer">
                                <div class="legend">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleDeleteSpaceDataAndSpace.bind(this)}>
                                    Delete
                                    </button>
                                    <button type="button" data-loading-text="Loading..." class="btn btn-warning btn-fill pull-right" autoComplete="off" onClick={this.handleDeleteSpaceData.bind(this)}>
                                    Clear Data
                                    </button>
                                    <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleSaveSpaceData.bind(this)}>
                                    Update
                                    </button>
                                    <div class="clearfix"></div>
                                </div>
                                <hr/>
                                <div class="stats">
                                    <i class="fa fa-clock-o"></i> Last updated {this.state.lastUpdated}
                                    {contractData && (
                                        <span>
                                            <i class="fa fa-usd"></i>{this.formatAmount(contractData.contract_amount)} - {contractData.payment_recurrence_method}ly
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        } else {
            // # IS MINIMIZED
            if(spaceDataID === undefined || spaceDataID == 0) {
                return (
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.maximizeTask}><i class="pe-7s-angle-up"></i></button>
                            <h4 class="title" onClick={this.props.maximizeTask}>Editing Space</h4>
                            <p class="category"></p>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div class="card">
                        <div class="header">
                            <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                            <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.maximizeTask}><i class="pe-7s-angle-up"></i></button>
                            <h4 class="title" onClick={this.props.maximizeTask}>Editing: {this.state.spaceDetails.taskTitle}</h4>
                            <p class="category"></p>
                        </div>
                    </div>
                );
            }
        }
    }
};


// WEBPACK FOOTER //
// app/components/MultiTaskManager/Type/Space.jsx